"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require("babel-runtime/helpers/classCallCheck");

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require("babel-runtime/helpers/createClass");

var _createClass3 = _interopRequireDefault(_createClass2);

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

var _moment = require("moment");

var _moment2 = _interopRequireDefault(_moment);

var _axios = require("axios");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : { default: obj };
}

var Synch = function () {
  function Synch(data) {
    (0, _classCallCheck3.default)(this, Synch);

    this.emailAddress = data.emailAddress;
    this.customer = data.customer;
  }

  (0, _createClass3.default)(Synch, [{
    key: "grabPrescriptions",
    value: function grabPrescriptions() {
      var data = [];
      var url = "https://www.sunniessystems.com/api/3.0/324566/prescriptions/";
      var apiKey = "052398FSOWRI2UR7FHJKG789403JHFSA";
      var headers = {
        "oassis-api-key": apiKey
      };
      var params = {
        email_address: this.emailAddress,
        client_id: "95jgnvudiht03075kdhfrw256789dhif",
        patient_id: ""
      };

      function mapPrescription(prescriptions) {
        var dataArrays = prescriptions.prescriptions_historical;

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = dataArrays[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var prescription = _step.value;

            var lens = prescription.lens_name ? prescription.lens_name.split("-")[1].toUpperCase() : "";

            var object = {
              id: prescription.prescription_id || "",
              prescriptionSet: false,
              newPrescription: false,
              store: prescription.branch_name || "",
              date: prescription.order_date_created,
              type: prescription.prescription_purpose || "",
              left: {
                sph: prescription.sph_os,
                cyl: prescription.cyl_os,
                axis: prescription.axis_os,
                add: prescription.add_os,
                ipd: prescription.ipd_os,
                ph: prescription.ph_os
              },
              right: {
                sph: prescription.sph_od,
                cyl: prescription.cyl_od,
                axis: prescription.axis_od,
                add: prescription.add_od,
                ipd: prescription.ipd_od,
                ph: prescription.ph_od
              },
              frame: prescription.frame_name || "",
              lens: lens
            };

            data.push(object);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }

      function createTiles(data) {
        var buttons = "";
        (0, _jquery2.default)("#grab_prescription_result").html("");

        if (data.length < 1) {
          // Show no prescriptions found
          (0, _jquery2.default)("#grab_prescription_no_result").show();
        } else {
          for (var index = 0; index < data.length; index++) {
            var curPrescription = data[index];

            var date = (0, _moment2.default)(curPrescription.date).format("L");
            var dateLaunch = 20201031;
            var dateCreated = (0, _moment2.default)(curPrescription.date).format("YYYYMMDD");

            var prxDate = date;
            var prxFrame = curPrescription.frame.toUpperCase();
            var prxType = curPrescription.type.toUpperCase();
            var prxLens = curPrescription.lens;
            var prxRight = curPrescription.right.sph + " / " + curPrescription.right.cyl + " / " + curPrescription.right.add;
            var prxLeft = curPrescription.left.sph + " / " + curPrescription.left.cyl + " / " + curPrescription.left.add;
            var prxStore = curPrescription.store.toUpperCase();

            // Virtual Store branch renaming
            if (prxStore.toLowerCase() == "virtual store" || prxStore.toLowerCase() == "virtual store international") {
              if (dateCreated > dateLaunch) {
                prxStore = "sunniesstudios.com";
              } else {
                prxStore = "sunniesspecs.com";
              }
            }

            var button = '<button type="button" class="Step1__prescriptions-button gp-button" data-prx-right-sph="' + curPrescription.right.sph + '" data-prx-right-cyl="' + curPrescription.right.cyl + '" data-prx-right-axis="' + curPrescription.right.axis + '" data-prx-right-add="' + curPrescription.right.add + '" data-prx-right-ipd="' + curPrescription.right.ipd + '" data-prx-right-ph="' + curPrescription.right.ph + '" data-prx-left-sph="' + curPrescription.left.sph + '" data-prx-left-cyl="' + curPrescription.left.cyl + '" data-prx-left-axis="' + curPrescription.left.axis + '" data-prx-left-add="' + curPrescription.left.add + '" data-prx-left-ipd="' + curPrescription.left.ipd + '" data-prx-left-ph="' + curPrescription.left.ph + '" data-prx-type="' + prxType + '" style="margin-right: 15px;"><p>ORDERED ON: <span>' + prxDate + "</span></p> <p>FRAMES: <span>" + prxFrame + "</span></p> <p>VISION: <span>" + prxType + "</span></p> <p>LENS: <span>" + prxLens + "</span></p> <p>RIGHT: <span>" + prxRight + "</span></p> <p>LEFT: <span>" + prxLeft + "</span></p> <p>STORE PURCHASED: <span>" + prxStore + "</span></p></button>";

            buttons = buttons + button;
          }

          // Hide no prescriptions found
          (0, _jquery2.default)("#grab_prescription_no_result").hide();

          // Create buttons
          (0, _jquery2.default)("#grab_prescription_result").html(buttons);

          (0, _jquery2.default)(".gp-button").click(function () {
            // Set tile active
            (0, _jquery2.default)("#grab_prescription_result .active").removeClass("active");
            (0, _jquery2.default)(this).addClass("active");
            // Set current data
            var curRightSPH = (0, _jquery2.default)(this).data("prx-right-sph");
            var curRightCYL = (0, _jquery2.default)(this).data("prx-right-cyl");
            var curRightAXIS = (0, _jquery2.default)(this).data("prx-right-axis");
            var curRightADD = (0, _jquery2.default)(this).data("prx-right-add");
            var curRightIPD = (0, _jquery2.default)(this).data("prx-right-ipd");
            var curRightPH = (0, _jquery2.default)(this).data("prx-right-ph");
            var curLeftSPH = (0, _jquery2.default)(this).data("prx-left-sph");
            var curLeftCYL = (0, _jquery2.default)(this).data("prx-left-cyl");
            var curLeftAXIS = (0, _jquery2.default)(this).data("prx-left-axis");
            var curLeftADD = (0, _jquery2.default)(this).data("prx-left-add");
            var curLeftIPD = (0, _jquery2.default)(this).data("prx-left-ipd");
            var curLeftPH = (0, _jquery2.default)(this).data("prx-left-ph");
            // Set Type
            var curType = (0, _jquery2.default)(this).data("prx-type").toLowerCase();
            (0, _jquery2.default)("#vb-" + curType).click();
            (0, _jquery2.default)(".vb-tiles").removeClass("active");
            (0, _jquery2.default)("#vb-" + curType).addClass("active");
            // Fill up prescription table
            (0, _jquery2.default)("#gp-right-sph").val(curRightSPH.toFixed(2));
            if (curRightCYL == "0.00") {
              (0, _jquery2.default)("#gp-right-cyl").val(curRightCYL);
            } else {
              (0, _jquery2.default)("#gp-right-cyl").val(curRightCYL.toFixed(2));
            }
            (0, _jquery2.default)("#gp-right-axis").val(curRightAXIS);
            (0, _jquery2.default)("#gp-right-add").val(curRightADD.toFixed(2));
            (0, _jquery2.default)("#gp-right-ipd").val(curRightIPD.toFixed(1));
            (0, _jquery2.default)("#gp-right-ph").val(curRightPH);
            (0, _jquery2.default)("#gp-left-sph").val(curLeftSPH.toFixed(2));
            if (curRightCYL == "0.00") {
              (0, _jquery2.default)("#gp-left-cyl").val(curLeftCYL);
            } else {
              (0, _jquery2.default)("#gp-left-cyl").val(curLeftCYL.toFixed(2));
            }
            (0, _jquery2.default)("#gp-left-axis").val(curLeftAXIS);
            (0, _jquery2.default)("#gp-left-add").val(curLeftADD.toFixed(2));
            (0, _jquery2.default)("#gp-left-ipd").val(curLeftIPD.toFixed(1));
            (0, _jquery2.default)("#gp-left-ph").val(curLeftPH);
          });
        }
      }

      (0, _axios2.default)({
        url: url,
        method: "get",
        headers: headers,
        params: params
      }).then(function (result) {
        mapPrescription(result.data);
        createTiles(data);
      }).catch(function (error) {
        return console.log(error);
      });
    }
  }]);
  return Synch;
}();

exports.default = Synch;